// ============================================================
// STARDATE SCENT QUIZ — CONFIGURATION FILE
// ============================================================
// This is the ONLY file you need to edit for content changes.
// Do not edit scent-quiz.js unless changing quiz behaviour.
// ============================================================

window.QUIZ_CONFIG = {

  // ----------------------------------------------------------
  // FRAGRANCE MASTER TABLE
  // ----------------------------------------------------------
  fragrances: {
    Aries:       { name: 'Ember Tide',      notes: 'Crushed Lime + Sea Salt',          traits: 'Bold · Fresh · Energetic',       zodiac: 'Aries',
                   description: 'Ember Tide is a bold, fresh fragrance that captures the energy of the ocean at dawn — invigorating, alive, and utterly unforgettable.',
                   topNotes: 'Orange Zest + Kaffir Lime', heartNotes: 'Sea Salt + Saffron', baseNotes: 'Amber + Cedarwood' },

    Taurus:      { name: 'Nocturne Bloom',  notes: 'Vanilla + Patchouli + Sandalwood', traits: 'Sensual · Warm · Grounded',       zodiac: 'Taurus',
                   description: 'Nocturne Bloom is a rich, sensual fragrance that wraps around you like a warm embrace on a cool evening.',
                   topNotes: 'Bergamot + Lemon Peel', heartNotes: 'Cedarwood + Patchouli', baseNotes: 'Vanilla + White Musk' },

    Gemini:      { name: 'Velvet Reverie', notes: 'Lime + Coconut + Elderflower',     traits: 'Playful · Bright · Social',       zodiac: 'Gemini',
                   description: 'Velvet Reverie is a playful, indulgent fragrance that blends citrus brightness with creamy coconut and caramel — sweet, social, and impossible to forget.',
                   topNotes: 'Bergamot + Lime', heartNotes: 'Coconut + Burned Sugar', baseNotes: 'Caramel + Vanilla' },

    Cancer:      { name: 'Golden Embrace',  notes: 'Cinnamon + Vanilla',               traits: 'Comfort · Warm · Nurturing',      zodiac: 'Cancer',
                   description: 'Golden Embrace is a warm, comforting fragrance that feels like home - cosy, familiar, and deeply reassuring.',
                   topNotes: 'Lemon Zest + Nutmeg', heartNotes: 'Cinnamon + Buttercream', baseNotes: 'Vanilla Bean + Malt' },

    Leo:         { name: 'Solar Reign',     notes: 'Bergamot + Patchouli',             traits: 'Luxurious · Confident · Radiant', zodiac: 'Leo',
                   description: 'Solar Reign is a bold, luxurious fragrance that commands attention and radiates confidence from the moment it touches skin.',
                   topNotes: 'Tangelo + Bergamot', heartNotes: 'Gardenia + Jasmine', baseNotes: 'Patchouli + Vetiver' },

    Virgo:       { name: 'Arcane Grace',    notes: 'Sandalwood + Vanilla',             traits: 'Clean · Calm · Refined',          zodiac: 'Virgo',
                   description: 'Arcane Grace is a quietly sophisticated fragrance — bright citrus softened by orchid and jasmine, settling into warm sandalwood. Refined, understated, and effortlessly elegant.',
                   topNotes: 'Lime + Grapefruit', heartNotes: 'Orchid + Jasmine', baseNotes: 'Sandalwood + Vanilla' },

    Libra:       { name: 'Fleur Amour',     notes: 'Cherry Blossom + Patchouli',           traits: 'Romantic · Elegant · Feminine',   zodiac: 'Libra',
                   description: 'Fleur Amour is a light, romantic, elegant fragrance that blooms like a garden in spring — feminine, graceful, and utterly charming.',
                   topNotes: 'Blackberry + Lemon', heartNotes: 'Tuberose + Cherry Blossom', baseNotes: 'White Musk + Patchouli + Sandalwood + Amber' },

    Scorpio:     { name: 'Tempest Veil',    notes: 'Marine Air + Coastal Wood',               traits: 'Reminiscent · Sensual · Intense',        zodiac: 'Scorpio',
                   description: 'Tempest Veil is a fragrance of depth and intensity — on the surface, fresh and unexpected; underneath, layers of coastal wood and earthy vetiver that reveal themselves slowly. For someone who sees beneath the surface, and rewards those who look closer.',
                   topNotes: 'Lime + Peppercorn', heartNotes: 'Coconut Water + Seagrass', baseNotes: 'Vetiver + Cedar + Oak Moss' },

    Sagittarius: { name: 'Nomadic Light',   notes: 'Orange Peel + Cedarwood',       traits: 'Adventurous · Vibrant · Warm',           zodiac: 'Sagittarius',
                   description: 'Nomadic Light is a vibrant, adventurous fragrance that captures the spirit of exploration and the warmth of far-off places.',
                   topNotes: 'Fir Needle + Orange Peel', heartNotes: 'Strawberry + Hyacinth', baseNotes: 'Patchouli + Vanilla + White Musk' },

    Capricorn:   { name: 'Ambitione',       notes: 'Black Raspberry + Vanilla',        traits: 'Sophisticated · Elegant · Sweet',         zodiac: 'Capricorn',
                   description: 'Ambitione is a sweet, sophisticated fragrance with quiet ambition — lush berries and delicate florals that settle into warm vanilla and musk. Driven, polished, and unapologetically indulgent.',
                   topNotes: 'Blackberry + Raspberry', heartNotes: 'Rose + Jasmine', baseNotes: 'Vanilla + Musk' },

    Aquarius:    { name: 'Auric Ambrosia',  notes: 'Caramel + Vanilla',                traits: 'Unique · Creative',               zodiac: 'Aquarius',
                   description: 'Auric Ambrosia is a decadently sweet fragrance that breaks every rule — salted caramel, creamy vanilla, and warm balsamic depth for someone who was never going to play it safe.',
                   topNotes: 'Creamy Vanilla + Tonka Bean', heartNotes: 'Salted Caramel + Coconut', baseNotes: 'Buttery Balsamic' },

    Pisces:      { name: 'Seraphine',       notes: 'Lavender + Ylang Ylang',           traits: 'Soft · Dreamy · Calm',            zodiac: 'Pisces',
                   description: 'Seraphine is a soft, dreamy fragrance that floats like a daydream — calming, ethereal, and beautifully gentle.',
                   topNotes: 'Orange + Grapefruit', heartNotes: 'Lavender + Ylang Ylang', baseNotes: 'Tonka Bean + Cinnamon' }
  },

  // ----------------------------------------------------------
  // FRAGRANCE IMAGE FILENAMES
  // Upload to Shopify Admin → Content → Files
  // Name files exactly as listed below.
  // ----------------------------------------------------------
  fragranceImages: {
    'Ember Tide':      'quiz-fragrance-ember-tide.jpg',
    'Nocturne Bloom':  'quiz-fragrance-nocturne-bloom.jpg',
    'Velvet Reverie': 'quiz-fragrance-velvet-reverie.jpg',
    'Golden Embrace':  'quiz-fragrance-golden-embrace.jpg',
    'Solar Reign':     'quiz-fragrance-solar-reign.jpg',
    'Arcane Grace':    'quiz-fragrance-arcane-grace.jpg',
    'Fleur Amour':     'quiz-fragrance-fleur-amour.jpg',
    'Tempest Veil':    'quiz-fragrance-tempest-veil.jpg',
    'Nomadic Light':   'quiz-fragrance-nomadic-light.jpg',
    'Ambitione':       'quiz-fragrance-ambitione.jpg',
    'Auric Ambrosia':  'quiz-fragrance-auric-ambrosia.jpg',
    'Seraphine':       'quiz-fragrance-seraphine.jpg'
  },

  fragranceHandles: {
  Aries:       'ember-tide',
  Taurus:      'nocturne-bloom',
  Gemini:      'velvet-reverie',
  Cancer:      'golden-embrace',
  Leo:         'solar-reign',
  Virgo:       'arcane-grace',
  Libra:       'fleur-amour',
  Scorpio:     'tempest-veil',
  Sagittarius: 'nomadic-light',
  Capricorn:   'ambitione',
  Aquarius:    'auric-ambrosia',
  Pisces:      'seraphine'
},

  // ----------------------------------------------------------
  // MONTH TAG MAP
  // Must match your exact Shopify product tags.
  // ----------------------------------------------------------
  monthTagMap: {
    1:'Jan', 2:'Feb', 3:'Mar', 4:'Apr',
    5:'May', 6:'Jun', 7:'Jul', 8:'Aug',
    9:'Sep', 10:'Oct', 11:'Nov', 12:'Dec'
  },

  // ----------------------------------------------------------
  // PRODUCT TYPE TAGS
  // ----------------------------------------------------------
  productTypeTags: {
    birthdayCandle:   'birthday candle',
    birthdayDiffuser: 'diffuser',
    giftCard:         'gift-card'
  },

  // ----------------------------------------------------------
  // TESTIMONIALS — one per product type tag
  // ----------------------------------------------------------
  testimonials: {
    'birthday candle': { quote: 'The most beautiful personalised gift. She cried when she opened it — in the best way.', author: 'Sarah M.' },
    'diffuser':        { quote: 'The diffuser looks stunning and the scent fills the whole room. An incredible gift.', author: 'Emma L.' },
    'gift-card':       { quote: 'Such a thoughtful way to let someone choose their own Stardate experience.', author: 'Olivia R.' }
  },

  // ----------------------------------------------------------
  // FEATURE ICONS — upload to Shopify Files and paste URLs here
  // ----------------------------------------------------------
  featureIcons: {
  handPoured:   'https://cdn.shopify.com/s/files/1/0599/4830/2495/files/Australia_Icon_ae73810a-9810-47b9-a66e-56090b1020f8.svg?v=1779456972',
  personalised: 'https://cdn.shopify.com/s/files/1/0599/4830/2495/files/Handmade_Icon_641c2fa1-9e69-4bf6-a5c1-3769f3b29bda.svg?v=1779449426',
  fastDispatch: 'https://cdn.shopify.com/s/files/1/0599/4830/2495/files/Fast_Dispatch_Icon_a4237a45-089a-4696-8b6d-72f5eeda6765.png?v=1779456973'
},

  // ----------------------------------------------------------
  // ZODIAC DATE RANGES
  // ----------------------------------------------------------
  zodiacDates: [
    { sign: 'Capricorn',   start: { m:12, d:22 }, end: { m:1,  d:19 } },
    { sign: 'Aquarius',    start: { m:1,  d:20 }, end: { m:2,  d:18 } },
    { sign: 'Pisces',      start: { m:2,  d:19 }, end: { m:3,  d:20 } },
    { sign: 'Aries',       start: { m:3,  d:21 }, end: { m:4,  d:19 } },
    { sign: 'Taurus',      start: { m:4,  d:20 }, end: { m:5,  d:20 } },
    { sign: 'Gemini',      start: { m:5,  d:21 }, end: { m:6,  d:20 } },
    { sign: 'Cancer',      start: { m:6,  d:21 }, end: { m:7,  d:22 } },
    { sign: 'Leo',         start: { m:7,  d:23 }, end: { m:8,  d:22 } },
    { sign: 'Virgo',       start: { m:8,  d:23 }, end: { m:9,  d:22 } },
    { sign: 'Libra',       start: { m:9,  d:23 }, end: { m:10, d:22 } },
    { sign: 'Scorpio',     start: { m:10, d:23 }, end: { m:11, d:21 } },
    { sign: 'Sagittarius', start: { m:11, d:22 }, end: { m:12, d:21 } }
  ],
  zodiacMeta: {
  Aries:       { dates: 'Mar 21 — Apr 19', element: 'Fire',  ruler: 'Mars',     traits: 'Bold, Passionate, Daring' },
  Taurus:      { dates: 'Apr 20 — May 20', element: 'Earth', ruler: 'Venus',    traits: 'Sensual, Patient, Indulgent' },
  Gemini:      { dates: 'May 21 — Jun 20', element: 'Air',   ruler: 'Mercury',  traits: 'Witty, Curious, Adaptable' },
  Cancer:      { dates: 'Jun 21 — Jul 22', element: 'Water', ruler: 'The Moon', traits: 'Intuitive, Romantic, Fiercely Loyal' },
  Leo:         { dates: 'Jul 23 — Aug 22', element: 'Fire',  ruler: 'The Sun',  traits: 'Radiant, Generous, Magnetic' },
  Virgo:       { dates: 'Aug 23 — Sep 22', element: 'Earth', ruler: 'Mercury',  traits: 'Precise, Analytical, Quietly Powerful' },
  Libra:       { dates: 'Sep 23 — Oct 22', element: 'Air',   ruler: 'Venus',    traits: 'Charming, Romantic, Balanced' },
  Scorpio:     { dates: 'Oct 23 — Nov 21', element: 'Water', ruler: 'Pluto',    traits: 'Intense, Sensual, Magnetic' },
  Sagittarius: { dates: 'Nov 22 — Dec 21', element: 'Fire',  ruler: 'Jupiter',  traits: 'Adventurous, Optimistic, Free' },
  Capricorn:   { dates: 'Dec 22 — Jan 19', element: 'Earth', ruler: 'Saturn',   traits: 'Ambitious, Disciplined, Sophisticated' },
  Aquarius:    { dates: 'Jan 20 — Feb 18', element: 'Air',   ruler: 'Uranus',   traits: 'Visionary, Independent, Unconventional' },
  Pisces:      { dates: 'Feb 19 — Mar 20', element: 'Water', ruler: 'Neptune',  traits: 'Dreamy, Empathetic, Mystical' }
},

  // ----------------------------------------------------------
  // SCORING WEIGHTS
  // Multipliers applied: Energy ×2, Vibe ×1.5, Scent Family ×3, Occasion ×1
  // Zodiac bonus: +50 (added to user's actual zodiac sign)
  // ----------------------------------------------------------
  scoring: {
    personality: {
      'Bold + Adventurous':    { Aries:0, Taurus:0, Gemini:0, Cancer:0, Leo:0, Libra:0, Virgo:0, Scorpio:8, Sagittarius:14, Capricorn:6, Aquarius:6, Pisces:0 },
      'Calm + Grounded':       { Aries:0, Taurus:0, Gemini:0, Cancer:0, Leo:0, Libra:20, Virgo:6, Scorpio:0, Sagittarius:0, Capricorn:0, Aquarius:0, Pisces:12 },
      'Social + Charming':     { Aries:14, Taurus:0, Gemini:0, Cancer:0, Leo:16, Libra:0, Virgo:0, Scorpio:0, Sagittarius:0, Capricorn:10, Aquarius:10, Pisces:0 },
      'Warm + Nurturing':      { Aries:0, Taurus:20, Gemini:0, Cancer:20, Leo:0, Libra:0, Virgo:14, Scorpio:0, Sagittarius:6, Capricorn:0, Aquarius:0, Pisces:0 },
      'Creative + Expressive': { Aries:6, Taurus:0, Gemini:20, Cancer:0, Leo:4, Libra:0, Virgo:0, Scorpio:0, Sagittarius:0, Capricorn:4, Aquarius:4, Pisces:4 },
      'Mysterious + Intense':  { Aries:0, Taurus:0, Gemini:0, Cancer:0, Leo:0, Libra:0, Virgo:0, Scorpio:12, Sagittarius:0, Capricorn:0, Aquarius:0, Pisces:4 }
    },
    vibe: {
      'A glamorous night out':                { Aries:0, Taurus:0, Gemini:7, Cancer:0, Leo:7, Libra:0, Virgo:0, Scorpio:9, Sagittarius:0, Capricorn:15, Aquarius:7, Pisces:0 },
      'A cosy night in':                      { Aries:0, Taurus:7, Gemini:0, Cancer:7, Leo:0, Libra:9, Virgo:15, Scorpio:0, Sagittarius:15, Capricorn:0, Aquarius:0, Pisces:7 },
      'Dancing with friends':                 { Aries:0, Taurus:0, Gemini:15, Cancer:0, Leo:15, Libra:0, Virgo:0, Scorpio:0, Sagittarius:0, Capricorn:7, Aquarius:15, Pisces:0 },
      'An intimate dinner party':             { Aries:0, Taurus:10, Gemini:0, Cancer:15, Leo:0, Libra:0, Virgo:6, Scorpio:0, Sagittarius:6, Capricorn:0, Aquarius:0, Pisces:0 },
      'Something luxurious and unforgettable':{ Aries:6, Taurus:15, Gemini:0, Cancer:0, Leo:0, Libra:6, Virgo:12, Scorpio:12, Sagittarius:9, Capricorn:0, Aquarius:0, Pisces:7 },
      'A relaxing self-care day':             { Aries:15, Taurus:0, Gemini:0, Cancer:7, Leo:0, Libra:15, Virgo:0, Scorpio:15, Sagittarius:0, Capricorn:0, Aquarius:0, Pisces:10 }
    },
    scentFamily: {
      'Fresh + Uplifting':  { Aries:30, Taurus:0, Gemini:9, Cancer:0, Leo:15, Libra:0, Virgo:0, Scorpio:21, Sagittarius:15, Capricorn:0, Aquarius:0, Pisces:0 },
      'Sweet + Indulgent':  { Aries:0, Taurus:6, Gemini:21, Cancer:6, Leo:9, Libra:0, Virgo:6, Scorpio:0, Sagittarius:0, Capricorn:30, Aquarius:30, Pisces:6 },
      'Floral + Romantic':  { Aries:0, Taurus:9, Gemini:0, Cancer:0, Leo:6, Libra:24, Virgo:0, Scorpio:0, Sagittarius:0, Capricorn:0, Aquarius:0, Pisces:18 },
      'Warm + Spicy':       { Aries:0, Taurus:15, Gemini:0, Cancer:24, Leo:0, Libra:0, Virgo:24, Scorpio:0, Sagittarius:9, Capricorn:0, Aquarius:0, Pisces:0 },
      'Earthy + Woody':     { Aries:0, Taurus:0, Gemini:0, Cancer:0, Leo:0, Libra:0, Virgo:0, Scorpio:9, Sagittarius:6, Capricorn:0, Aquarius:0, Pisces:0 },
      'Soft + Calming':     { Aries:0, Taurus:0, Gemini:0, Cancer:0, Leo:0, Libra:6, Virgo:0, Scorpio:0, Sagittarius:0, Capricorn:0, Aquarius:0, Pisces:6 }
    },
    occasion: {
      'Birthday':         { Aries:7, Taurus:7, Gemini:10, Cancer:7, Leo:10, Libra:7, Virgo:7, Scorpio:7, Sagittarius:7, Capricorn:7, Aquarius:7, Pisces:10 },
      'Wedding':          { Aries:0, Taurus:10, Gemini:6, Cancer:0, Leo:0, Libra:0, Virgo:10, Scorpio:8, Sagittarius:0, Capricorn:0, Aquarius:6, Pisces:5 },
      'Myself':           { Aries:7, Taurus:7, Gemini:7, Cancer:7, Leo:7, Libra:10, Virgo:7, Scorpio:7, Sagittarius:7, Capricorn:10, Aquarius:10, Pisces:7 },
      'Seasonal Holiday': { Aries:0, Taurus:0, Gemini:0, Cancer:10, Leo:0, Libra:0, Virgo:0, Scorpio:0, Sagittarius:10, Capricorn:0, Aquarius:0, Pisces:0 },
      'Just Because':     { Aries:10, Taurus:0, Gemini:0, Cancer:0, Leo:0, Libra:8, Virgo:0, Scorpio:10, Sagittarius:0, Capricorn:8, Aquarius:8, Pisces:0 },
      'Other':            { Aries:0, Taurus:0, Gemini:0, Cancer:0, Leo:0, Libra:0, Virgo:0, Scorpio:0, Sagittarius:0, Capricorn:0, Aquarius:0, Pisces:0 }
    },
    zodiacBonus: 50
  },

  // ----------------------------------------------------------
  // UI COPY
  // ----------------------------------------------------------
  copy: {
    loading: {
      lines: [
        '✨ Reading the stars…',
        'Analysing their personality…',
        'Finding their perfect scent…'
      ]
    },
    results: {
      fragranceHeading: "{{name}} Celestial Scent, Discovered.",
      fragranceSubtext: "Based on {{name}} personality, vibe, and star sign…",
      bestMatch:  'BEST MATCH',
      secondFave: 'Perfect Pairing',
      thirdLove:  'Let Them Choose',
      thirdLoveFragrance: 'Wild Card',
      pairCta:    'PAIR WITH GIFT ITEM',
      productHeading: "We've Found {{name}} Perfect Gift…",
      productSubtext: 'Chosen just for them based on their personality and zodiac energy.',
      addToCart:  'Add to Cart'
    }
  }
};